interface BadRequestDetails {
  readonly message: string;
}

export class BadRequest {
  constructor(public readonly details: BadRequestDetails) {}
}

export class ServerError {}

export class Unauthorized {}

export class Forbidden {}
